export default {"src":"/_next/static/media/Brand-logo.29de5675.svg","height":54,"width":145,"blurWidth":0,"blurHeight":0};